import { gsap } from "gsap";
import Accordions from './accordions';

export default class ContentSearchTabs {
    constructor() {
        this.init();
        this.handleMultiColumnLayout();
        this.handleResize();
    }

    init() {
        const navItems = document.querySelectorAll(".nav-item");
        const tabContents = document.querySelectorAll(".search-tabs_content");

        navItems.forEach((nav) => {
            nav.addEventListener("click", (e) => {
                e.preventDefault();
                this.toggleTabs(nav, navItems, tabContents);
            });
        });

        this.updateAccordionState();
    }

    // === RESET ACCORDIONS ===
    resetAccordions() {
        const activeTab = document.querySelector(".block-content-search .search-tabs_content.active");
        if (activeTab) {
            const accordions = activeTab.querySelectorAll(".accordion-item");
            accordions.forEach(accordion => {
                const accordionHeader = accordion.querySelector(".accordion-header");
                const accordionContent = accordion.querySelector(".accordion-content");

                if (!accordionHeader || !accordionContent) return;

                gsap.set(accordionContent, { height: "auto" });
                accordionHeader.animation = gsap.from(accordionContent, {
                    height: 0,
                    duration: 0.5,
                    ease: "power1.inOut",
                    reversed: true,
                });

                accordionHeader.classList.remove("active");
            });
        }

        this.updateAccordionState();
    }

    // === CLOSE ACCORDIONS BEFORE CHANGE TAB ===
    closeAccordions(content) {
        if (!content || !content.closest('.block-content-search')) return;

        const accordions = content.querySelectorAll(".accordion-item");
        accordions.forEach(accordion => {
            const accordionHeader = accordion.querySelector(".accordion-header");
            const accordionContent = accordion.querySelector(".accordion-content");

            if (!accordionHeader || !accordionContent) return;

            if (accordionHeader.animation) {
                accordionHeader.animation.reverse();
            }

            accordionHeader.classList.remove("active");
        });
    }

    // === TABS ===
    toggleTabs(nav, navItems, tabContents) {
        const tabId = nav.getAttribute("data-tab");
        const isLargeScreen = window.innerWidth >= 1200;

        if (nav.classList.contains("active")) return;

        navItems.forEach((el) => el.classList.remove("active"));

        tabContents.forEach((content) => {
            if (content.classList.contains("active")) {
                if (!isLargeScreen) {
                    this.closeAccordions(content);
                }

                gsap.to(content, {
                    autoAlpha: 0,
                    onStart: () => {
                        content.classList.remove("active");
                        content.style.display = "none";
                    },
                });
            }
        });

        nav.classList.add("active");

        const activeContent = document.querySelector(`.search-tabs_content[data-tab="${tabId}"]`);
        activeContent.style.display = "flex";

        gsap.to(activeContent, {
            autoAlpha: 1,
            onStart: () => {
                activeContent.classList.add("active");
            },
            onComplete: () => {
                if (!isLargeScreen) {
                    this.resetAccordions();
                }
            },
        });
    }

    // === FORCER L'OUVERTURE DES ACCORDÉONS SUR GRAND ÉCRAN ===
    updateAccordionState() {
        const isLargeScreen = window.innerWidth >= 1200;
        const activeTab = document.querySelector(".block-content-search .search-tabs_content.active");

        if (activeTab) {
            const accordions = activeTab.querySelectorAll(".accordion-item");
            accordions.forEach(accordion => {
                const accordionHeader = accordion.querySelector(".accordion-header");
                const accordionContent = accordion.querySelector(".accordion-content");

                if (!accordionHeader || !accordionContent) return;

                if (isLargeScreen) {
                    gsap.set(accordionContent, { height: "auto" });
                    accordionHeader.classList.add("active");
                    if (accordionHeader.animation) {
                        accordionHeader.animation.play();
                    }
                } else {
                    accordionHeader.classList.remove("active");
                    if (accordionHeader.animation) {
                        accordionHeader.animation.reverse();
                    }
                }
            });
        }

        this.disableAccordionClickOnDesktop();
    }


    // === DISABLE CLICK ON DESKTOP ===
    disableAccordionClickOnDesktop() {
        const isLargeScreen = window.innerWidth >= 1200;
        const accordionHeaders = document.querySelectorAll(".block-content-search .accordion-header");

        accordionHeaders.forEach(header => {
            if (isLargeScreen) {
                header.style.pointerEvents = "none";
            } else {
                header.style.pointerEvents = "";
            }
        });
    }


    // === ÉCOUTER LES CHANGEMENTS DE TAILLE D'ÉCRAN ===
    handleResize() {
        window.addEventListener("resize", () => {
            this.updateAccordionState();
            this.disableAccordionClickOnDesktop();
        });
    }


    // === ADD CLASS ON CATEGORY WITH 6 MORE SUB_CAT ===
    handleMultiColumnLayout() {
        const categoryLists = document.querySelectorAll('.category-list');

        categoryLists.forEach(categoryList => {
            const allItems = Array.from(categoryList.querySelectorAll('.category-list-item'));
            const allIndex = allItems.findIndex(item => item.classList.contains('category-list-item-all'));

            if (allIndex > -1) {
                const itemsAfterAll = allItems.slice(allIndex + 1);
                if (itemsAfterAll.length > 6) {
                    categoryList.classList.add('multi-column');
                    categoryList.closest('.category').classList.add('category-multi-column');
                    const columns = 2;
                    const items = itemsAfterAll.length + 1;
                    const rows = Math.ceil(items / columns);

                    categoryList.style.gridTemplateRows = `repeat(${rows}, auto)`;
                }
            }
        });
    }
}
